import { useState } from "react";
import { Colors } from "../constants";

export default () => {
  let [ loadingComponent, setLoadingComponent ] = useState(false);
  let [ color, setColor ] = useState(`#${Colors.primaryColor}`);

  let showLoading = (color  = false) => {
    setLoadingComponent(true);
    if(color) setColor(color);
  };

  let hideLoading = () => {
    setLoadingComponent(false);
  }
  return { loadingComponent, showLoading, hideLoading, color };
};
